import React from "react";
import { useFocus, useNumberInputFilter } from "../../../../../hooks";
import { formatNumberWhole, getCents } from "../../../../../utils/helpers/stringHelper";
import { StyledInput } from "../../../../../components/input/input";

const styliseValue = (value) => {
  const formattedValue = formatNumberWhole(value);
  return formattedValue ? formattedValue + (getCents(value) || ".00") : "";
};

const maxLengthForDecimalPlaces = (maxLength, decimalPlaces) => {
  if (decimalPlaces === 0) {
    return maxLength;
  }

  return maxLength + decimalPlaces + 1;
}

export const NumberInput = React.forwardRef((props, externalRef) => {
  const { name, type, value, onBlur, placeholder, maxLength, inputMode, customFieldUpdater, decimalPlaces = 0, disabled } = props;
  const [isFocused, ref] = useFocus(false, externalRef);
  const handleChange = useNumberInputFilter(name, decimalPlaces, customFieldUpdater);

  const stylisedValue = styliseValue(value);

  return (
    <>
      <StyledInput
        ref={ref}
        disabled={disabled}
        type={type}
        onBlur={onBlur}
        name={name}
        aria-labelledby={`${name}Label`}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={isFocused ? maxLengthForDecimalPlaces(maxLength, decimalPlaces) : maxLength + 4}
        inputMode={inputMode}
        value={isFocused ? value : stylisedValue}
      />
    </>
  )
});